import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Contact() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="./logo.png" 
                alt="IMAM BICHI DATA SUB Logo" 
                className="h-12 w-auto object-contain"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/#services" className="text-sm font-medium text-gray-700 hover:text-[#1e3a8a] transition-colors whitespace-nowrap cursor-pointer">Services</Link>
              <Link to="/#how-it-works" className="text-sm font-medium text-gray-700 hover:text-[#1e3a8a] transition-colors whitespace-nowrap cursor-pointer">How It Works</Link>
              <Link to="/contact" className="text-sm font-medium text-[#1e3a8a] transition-colors whitespace-nowrap cursor-pointer">Contact</Link>
              <button className="px-5 py-2.5 text-sm font-medium text-[#1e3a8a] border-2 border-[#1e3a8a] rounded-lg hover:bg-[#1e3a8a] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                Login
              </button>
              <button className="px-5 py-2.5 text-sm font-medium text-white bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-colors whitespace-nowrap cursor-pointer">
                Register
              </button>
            </div>

            <button 
              className="md:hidden p-2 cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100">
            <div className="px-4 py-4 space-y-3">
              <Link to="/#services" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Services</Link>
              <Link to="/#how-it-works" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">How It Works</Link>
              <Link to="/contact" className="block text-sm font-medium text-[#1e3a8a] py-2 cursor-pointer">Contact</Link>
              <button className="w-full px-5 py-2.5 text-sm font-medium text-[#1e3a8a] border-2 border-[#1e3a8a] rounded-lg hover:bg-[#1e3a8a] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                Login
              </button>
              <button className="w-full px-5 py-2.5 text-sm font-medium text-white bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-colors whitespace-nowrap cursor-pointer">
                Register
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Get in Touch
          </h1>
          <p className="text-lg text-white/90 leading-relaxed">
            We're here to help! Reach out to us through any of the channels below and we'll respond as quickly as possible.
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <a 
              href="https://wa.me/2348033838987" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-col items-center gap-4 p-8 bg-[#fef3c7] border-2 border-[#fbbf24]/30 rounded-xl hover:border-[#fbbf24] hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#fbbf24] rounded-full flex items-center justify-center">
                <i className="ri-whatsapp-line text-3xl text-white"></i>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-[#1e3a8a] mb-1">WhatsApp</div>
                <div className="text-sm text-gray-600">Chat with us now</div>
              </div>
            </a>

            <a 
              href="tel:+2348039929272"
              className="flex flex-col items-center gap-4 p-8 bg-[#dbeafe] border-2 border-[#1e3a8a]/30 rounded-xl hover:border-[#1e3a8a] hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#1e3a8a] rounded-full flex items-center justify-center">
                <i className="ri-phone-line text-3xl text-white"></i>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-[#1e3a8a] mb-1">Phone</div>
                <div className="text-sm text-gray-600">+234 803 992 9272</div>
              </div>
            </a>

            <a 
              href="mailto:support@imambichi.com"
              className="flex flex-col items-center gap-4 p-8 bg-[#fef3c7] border-2 border-[#fbbf24]/30 rounded-xl hover:border-[#fbbf24] hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#fbbf24] rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-3xl text-white"></i>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-[#1e3a8a] mb-1">Email</div>
                <div className="text-sm text-gray-600">support@imambichi.com</div>
              </div>
            </a>

            <div className="flex flex-col items-center gap-4 p-8 bg-[#dbeafe] border-2 border-[#1e3a8a]/30 rounded-xl">
              <div className="w-16 h-16 bg-[#1e3a8a] rounded-full flex items-center justify-center">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-[#1e3a8a] mb-1">Available</div>
                <div className="text-sm text-gray-600">24/7 Support</div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {/* Office Address */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border-2 border-gray-100">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 bg-[#fbbf24] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#1e3a8a] mb-2">Office Address</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Along Kano-Katsina Road, Opposite Old Kedco Office, Bichi, Kano State, Nigeria
                  </p>
                </div>
              </div>

              {/* Support Hours */}
              <div className="bg-white p-6 rounded-xl border-2 border-[#fbbf24]/20">
                <h4 className="text-base font-bold text-[#1e3a8a] mb-4">Support Hours</h4>
                <div className="space-y-3">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Monday - Friday</span>
                    <span className="font-semibold text-[#fbbf24]">24/7 Available</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Saturday - Sunday</span>
                    <span className="font-semibold text-[#fbbf24]">24/7 Available</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Public Holidays</span>
                    <span className="font-semibold text-[#fbbf24]">24/7 Available</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden border-2 border-[#1e3a8a]/20 h-full min-h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31324.89!2d8.2333!3d12.2333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x11ae820e0d7e7e7d%3A0x7e7e7e7e7e7e7e7e!2sBichi%2C%20Kano%2C%20Nigeria!5e0!3m2!1sen!2s!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="IMAM BICHI DATA SUB Location"
              ></iframe>
            </div>
          </div>

          {/* Quick Response Note */}
          <div className="mt-8 flex items-start gap-3 p-6 bg-[#fef3c7] rounded-xl border-2 border-[#fbbf24]">
            <i className="ri-information-line text-2xl text-[#1e3a8a] mt-0.5"></i>
            <p className="text-sm text-gray-700 leading-relaxed">
              Our support team typically responds within 5 minutes during business hours. For urgent issues, please use WhatsApp for fastest response.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <img 
                src="./whitelogo.png" 
                alt="IMAM BICHI DATA SUB" 
                className="h-12 w-auto object-contain mb-4"
              />
              <p className="text-sm text-gray-400 leading-relaxed">
                Your trusted partner for instant airtime, data, and bill payments in Nigeria.
              </p>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/#services" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Services</Link></li>
                <li><Link to="/#how-it-works" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">How It Works</Link></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Pricing</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">API Documentation</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">Support</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Help Center</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Terms of Service</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Privacy Policy</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Refund Policy</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">Contact Us</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-[#fbbf24] mt-0.5"></i>
                  <span className="text-sm text-gray-400"><a href="tel:+2348039929272"></a>+234 803 992 9272</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-[#fbbf24] mt-0.5"></i>
                  <span className="text-sm text-gray-400">support@imambichi.com</span>
                </li>
                <li>
                  <a 
                    href="https://wa.me/2348033838987" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-[#fbbf24] hover:bg-[#f59e0b] rounded-lg text-sm font-medium text-[#1e3a8a] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    WhatsApp Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-sm text-gray-400">
                © 2025 IMAM BICHI DATA SUB. All rights reserved.
              </p>
              <a 
                href="https://yusufias-portfolio.vercel.app" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer"
              >
                Developed By Yusufia Dev
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
